import React, { useState } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Chip, Box, Typography, Collapse, IconButton } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

const when = (d) => (d ? new Date(d).toLocaleString() : '-');
const took = (s) => (s == null ? '-' : s < 60 ? `${s} s` : `${Math.floor(s / 60)} min ${s % 60} s`);
const RESULT = { succeeded: 'success', failed: 'error', running: 'warning' };

function Row({ a, showHost }) {
  const [open, setOpen] = useState(false);
  const ended = a.detail?.ended || [];
  return (
    <>
      <TableRow hover>
        <TableCell padding="checkbox"><IconButton size="small" aria-label={`Details of request ${a.id}`} onClick={() => setOpen(!open)}>{open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}</IconButton></TableCell>
        <TableCell>{when(a.requested_at)}</TableCell>
        <TableCell>{a.requested_name || a.requested_by}</TableCell>
        {showHost && <TableCell>{a.host}<Typography variant="caption" color="text.secondary" display="block">{a.service_name}</Typography></TableCell>}
        <TableCell>{a.action === 'stop' ? 'Stop' : 'Start'}</TableCell>
        <TableCell><Chip size="small" color={RESULT[a.status]} label={a.status} /></TableCell>
        <TableCell>{a.reason}{a.ticket ? ` (${a.ticket})` : ''}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell colSpan={showHost ? 7 : 6} sx={{ py: 0, borderBottom: open ? undefined : 'none' }}>
          <Collapse in={open} unmountOnExit>
            <Box sx={{ py: 1 }}>
              <Typography variant="body2">Requested by {a.requested_by}{a.source_ip ? ` from ${a.source_ip}` : ''}. Took {took(a.took_seconds)}.{a.completed_at ? ` Finished ${when(a.completed_at)}.` : ''}</Typography>
              {a.detail?.before && <Typography variant="body2">Service was {a.detail.before}; afterwards {a.detail.after}.</Typography>}
              {a.action === 'start' && a.detail?.pid && <Typography variant="body2">New service process: {a.detail.pid}{a.detail.started ? `, started ${when(a.detail.started)}` : ''}.</Typography>}
              {a.error && <Typography variant="body2" color="error">{a.error}</Typography>}
              {ended.length > 0 && <Typography variant="body2">Processes ended: {ended.map((p) => `${p.name} (${p.pid})`).join(', ')}.</Typography>}
              {a.action === 'stop' && a.detail?.remaining?.length > 0 && <Typography variant="body2" color="error">Still running: {a.detail.remaining.map((p) => `${p.name} (${p.pid})`).join(', ')}.</Typography>}
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
}

function ServiceActionsTable({ rows, showHost = true }) {
  return (
    <TableContainer>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell padding="checkbox" /><TableCell>When</TableCell><TableCell>Who</TableCell>{showHost && <TableCell>Server and service</TableCell>}
            <TableCell>Action</TableCell><TableCell>Result</TableCell><TableCell>Reason</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>{rows.map((a) => <Row key={a.id} a={a} showHost={showHost} />)}</TableBody>
      </Table>
    </TableContainer>
  );
}

export default ServiceActionsTable;
